"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("rxjs/add/operator/toPromise");
/**
 *
 * @author Anania.Mikaelyan
 */
var FormManagementService = /** @class */ (function () {
    function FormManagementService() {
    }
    return FormManagementService;
}());
exports.FormManagementService = FormManagementService;
//# sourceMappingURL=form-management.service.js.map